module.exports = __webpack_public_path__ + "static/media/key.16cc9aba.svg";